import React from 'react';
import { WindowProvider } from '../contexts/WindowContext';
import { ToastProvider } from '../contexts/ToastContext';
import { SettingsProvider } from '../contexts/SettingsContext';
import { ModeProvider } from '../contexts/ModeContext';

interface UIProvidersProps {
  children: React.ReactNode;
}

export const UIProviders: React.FC<UIProvidersProps> = ({ children }) => {
  return (
    <WindowProvider>
      <ToastProvider>
        <SettingsProvider>
          <ModeProvider>
            {children}
          </ModeProvider>
        </SettingsProvider>
      </ToastProvider>
    </WindowProvider>
  );
};